var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiAssistantChatbotDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 58,
    viewBox: "0 0 48 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9981 57.0419C30.6504 57.0419 36.0431 44.5472 36.0431 29.1342C36.0431 13.7213 30.6504 1.22656 23.9981 1.22656C17.3459 1.22656 11.9531 13.7213 11.9531 29.1342C11.9531 44.5472 17.3459 57.0419 23.9981 57.0419Z",
    stroke: "#DC2418",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0223 17.7736C42.2785 25.4788 49.5185 36.8134 46.1923 43.0879C42.866 49.3623 30.2335 48.2011 17.9773 40.4945C5.72102 32.7879 -1.51773 21.456 1.80852 15.1802C3.13852 12.6713 5.95602 11.3521 9.64227 11.1642C15.176 10.8811 22.6673 13.1477 30.0223 17.7736Z",
    stroke: "#DC2418",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5373 25.3923H28.4623M18.1423 29.1346H29.8573M21.426 32.877H26.5735M30.0223 40.4951C17.766 48.2017 5.13477 49.3629 1.80852 43.0885C-1.51773 36.814 5.72102 25.4808 17.9773 17.7742C25.0548 13.3226 32.2573 11.0559 37.721 11.143C41.7185 11.2057 44.786 12.5289 46.1923 15.1808C49.5173 21.4553 42.2798 32.7885 30.0223 40.4951Z",
    stroke: "#DC2418",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAssistantChatbotDevelopment);
export default __webpack_public_path__ + "static/media/AIAssistantChatbotDevelopment.75ad504bad370b4948ce3045d52392a6.svg";
export { ForwardRef as ReactComponent };